import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { SentryDSN } from 'shared/sentry.io';

(function () {
    if (
        window.__SENTRY_IO_CONFIG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('FEATURE_FLAG') &&
        window.__SENTRY_IO_CONFIG.FEATURE_FLAG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('VIDEO_ENABLED') &&
        window.__SENTRY_IO_CONFIG.VIDEO_ENABLED
    ) {
        new Sentry.init({
            dsn: SentryDSN.videopage,
            release: window.__SENTRY_IO_CONFIG.BUILD_NUMBER ?? '',
            environment: window.location.hostname,
            integrations: [new Integrations.BrowserTracing()],
            tracesSampleRate: 0.1,
        });

        // Expose namespace for SmartTag
        window.Sentry = Sentry;
    }
})();
